import { useQueryParam, BooleanParam, useQueryParams, StringParam } from 'use-query-params';

export const usePleaseLogIn = () => useQueryParam('pleaseLogIn', BooleanParam);
export const usePleaseLogInAndRedirect = () =>
  useQueryParams({
    pleaseLogIn: BooleanParam,
    pleaseLogInRedirect: StringParam
  });
